// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"sdms2D_imgBox__2XEdg","mainImage":"sdms2D_mainImage__3SW1z","poiImgs":"sdms2D_poiImgs__V8qIE","selectedPoiImgs":"sdms2D_selectedPoiImgs__3Ablg"};